module.exports = __webpack_public_path__ + "static/egyptian-cotton-duvet-cover-navy-1-0ab153e591e698127b78146ce786e16a.png";